module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/054-canary-islands-f6bca2651d5bca297ca6c8db019e6e93.svg";